angular.module('olivioConfiguratorApp')
  .controller('DistributionCtrl', function ($scope, Model, Data, StepService) {
    //console.log('init DistributionCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;

    // init
    // check conditions
    Data.applyDistributionConstraints($scope.model);

    // $scope.model.distribution.individual FIXME gibt es noch nicht
    $scope.selectDistribution = function ($id) {
      var distribution = Data.getDistributionOption($id);
      if (distribution) {
        if ($scope.model.distribution.id !== $id) {
          $scope.model.distribution.id = $id;

          $scope.model.distribution.individual = new Array($scope.model.design.lumcount);
          for (var i = 0; i < $scope.model.design.lumcount; i++) {
            $scope.model.distribution.individual[i] = $id;
          }
          Model.resetPower();
          StepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = false;
        }
        $scope.model.distribution.done = true;
        StepService.nextStep();
      } // TODO else software configuration error
    };

  });
